import { render, staticRenderFns } from "./NewContract.vue?vue&type=template&id=afffc960&scoped=true&"
import script from "./NewContract.vue?vue&type=script&lang=js&"
export * from "./NewContract.vue?vue&type=script&lang=js&"
import style0 from "./NewContract.vue?vue&type=style&index=0&id=afffc960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afffc960",
  null
  
)

export default component.exports